import axios from 'axios'
import { BATCH_MEDIA_DOWNLOAD_TIMEOUT_MS } from './batchMediaDownload'

// 根据环境确定基础URL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境使用代理前缀
    return ''
  } else if (process.env.NODE_ENV === 'production') {
    // 生产环境
    return process.env.VUE_APP_API_BASE_URL || 'https://server.dongxin666.com'
  }
  return ''
}

// 创建axios实例
const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    
    // 登录和注册接口不需要token
    if (config.url === '/api/user/login' || config.url === '/api/User/login' || config.url === '/api/User/register') {
      return config
    }
    
    // 除了登录注册接口，其他所有接口都需要token
    if (token) {
      // 使用Authorization Bearer方式传递token
      config.headers.token = token
    } else {
      // 如果没有token，可以跳转到登录页面或抛出错误
      console.warn('请求需要token但未找到，请先登录')
      // 可以选择跳转到登录页面
      // window.location.href = '/login'
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    // 统一处理返回的msg，如果接口返回了msg，可以通过response.data.msg获取
    const data = response.data
    if (data && data.msg) {
      // msg信息可以在组件中通过返回的data获取
      // 这里不做处理，让组件自行处理msg
    }
    return response
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('userinfo')
      // 可以在这里跳转到登录页面
      window.location.href = '/'
    }
    
    // 处理其他错误，如果有返回msg，可以通过error.response.data.msg获取
    if (error.response && error.response.data && error.response.data.msg) {
      // 错误信息可以在组件中通过error.response.data.msg获取
    }
    
    return Promise.reject(error)
  }
)

// API接口定义
const api = {
  // 用户登录接口
  login: (data) => {
    return request({
      url: '/api/user/login',
      method: 'post',
      data: {
        account: data.account,
        password: data.password
      }
    })
  },
  
  // 获取用户信息接口
  getUserInfo: () => {
    return request({
      url: '/api/user/userinfo',
      method: 'get'
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 更新用户信息接口
  updateUserProfile: (data) => {
    return request({
      url: '/api/user/profile',
      method: 'post',
      data: {
        nickname: data.nickname,
        avatar: data.avatar
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 修改密码接口
  updatePassword: (data) => {
    return request({
      url: '/api/user/updatepwd',
      method: 'post',
      data: {
        password: data.password, // 旧密码
        newPassword: data.newPassword, // 新密码
        rePassword: data.rePassword // 确认密码
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 文件上传接口
  uploadFile: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    
    return request({
      url: '/api/common/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 设备相关接口
  // 获取设备状态统计
  getDeviceStatusNum: () => {
    return request({
      url: '/api/device/getStatusNum',
      method: 'get'
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 添加设备
  addDevice: (data) => {
    return request({
      url: '/api/device/add',
      method: 'post',
      data: {
        deviceId: data.deviceId, // 设备编号
        type: data.type, // 设备类型：1=摄像头, 2=录音
        password: data.password // 设备密码
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 删除设备
  deleteDevice: (id) => {
    return request({
      url: '/api/device/delete',
      method: 'get',
      params: {
        id: String(id) // 设备ID
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 编辑设备
  updateDevice: (data) => {
    return request({
      url: '/api/device/update',
      method: 'post',
      data: {
        deviceId: data.deviceId, // 设备编号（不可变）
        type: data.type // 设备类型：1=摄像头, 2=录音
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 获取设备列表
  getDeviceList: (params) => {
    return request({
      url: '/api/device/lst',
      method: 'get',
      params: {
        page: params.page || '1', // 第几页
        limit: params.limit || '20', // 每页几条
        keyword: params.keyword || '', // 关键词检索
        status: params.status || '', // 状态【0=离线, 1=空闲中, 2=工作中】
        type: params.type || '0' // 设备类型【0=全部, 1=摄像头, 2=录音】
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 获取设备详情
  getDeviceDetail: (id) => {
    return request({
      url: '/api/device/detail',
      method: 'get',
      params: {
        id: String(id) // 设备ID
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 更新设备阈值
  updateDeviceThreshold: (data) => {
    return request({
      url: '/api/device/threshold',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        threshold: String(data.threshold), // 阈值
        duration: String(data.duration || 300), // 报警录像时长
        cooldownSeconds: String(data.cooldownSeconds || 30) // 触发冷却时间
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 设备截图接口
  captureDevice: (data) => {
    return request({
      url: '/api/device/capture',
      method: 'post',
      data: {
        id: String(data.id) // 设备ID（详情返回的id字段）
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 视频设备控制接口
  controlVideo: (data) => {
    return request({
      url: '/api/device/controlVideo',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        action: String(data.action) // 操作类型：0-停止，1-启动
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },

  // 视频参数设置接口
  updateVideoConfig: (data) => {
    return request({
      url: '/api/device/videoConfig',
      method: 'post',
      data: {
        id: String(data.id),
        resolution: String(data.resolution)
      }
    })
  },
  
  // 录音设备控制接口
  segmentRecord: (data) => {
    return request({
      url: '/api/device/segmentRecord',
      method: 'post',
      data: {
        id: String(data.id), // 设备ID（详情返回的id字段）
        action: String(data.action) // 操作类型：0-停止，1-启动
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },
  
  // 获取设备文件列表接口
  getDeviceFileList: (params) => {
    return request({
      url: '/api/device/file_list',
      method: 'get',
      params: {
        deviceId: String(params.deviceId), // 设备ID（必选）
        page: String(params.page || '1'), // 第几页（必选）
        limit: String(params.limit || '20'), // 每页几条（必选）
        keyword: params.keyword || '', // 关键词检索（可选）
        type: params.type || '0', // 文件类型【0=全部, 1=图片, 2=录像, 3=声音】（可选）
        startTime: params.startTime || '', // 筛选开始时间（可选）
        endTime: params.endTime || '' // 筛选结束时间（可选）
      }
      // token会通过请求拦截器自动添加到headers中
    })
  },

  clearDeviceStorage: (data) => {
    return request({
      url: '/api/device/clearStorage',
      method: 'post',
      data: {
        id: String(data.id),
        includeLogs: Boolean(data.includeLogs || false)
      }
    })
  },

  createDeviceTask: (data) => {
    return request({
      url: '/api/device_task/create',
      method: 'post',
      data
    })
  },

  getDeviceTaskDetail: (params) => {
    return request({
      url: '/api/device_task/detail',
      method: 'get',
      params
    })
  },

  getDevicePackages: (params = {}) => {
    return request({
      url: '/api/device_deploy/package',
      method: 'get',
      params
    })
  },

  createDeviceDeployTask: (data) => {
    return request({
      url: '/api/device_deploy/create',
      method: 'post',
      data
    })
  },

  uploadOtaPackage: (data) => {
    return request({
      url: '/api/device_deploy/upload',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  batchCreateDeviceDeployTask: (data) => {
    return request({
      url: '/api/device_deploy/batchCreate',
      method: 'post',
      data
    })
  },

  batchDeviceMediaList: (data) => {
    return request({
      url: '/api/device/batchMediaList',
      method: 'post',
      data
    })
  },

  batchDeviceMediaDownload: (data) => {
    return request({
      url: '/api/device/batchMediaDownload',
      method: 'post',
      data,
      timeout: BATCH_MEDIA_DOWNLOAD_TIMEOUT_MS
    })
  },

  batchDeviceMediaDelete: (data) => {
    return request({
      url: '/api/device/batchMediaDelete',
      method: 'post',
      data
    })
  },

  batchUpdateDeviceConfig: (data) => {
    return request({
      url: '/api/device/batchConfig',
      method: 'post',
      data
    })
  },

  batchRebootDevice: (data) => {
    return request({
      url: '/api/device/batchReboot',
      method: 'post',
      data
    })
  },

  uploadCustomDeviceFile: (data) => {
    return request({
      url: '/api/device_deploy/customUpload',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  batchNetworkTest: (data) => {
    return request({
      url: '/api/device/batchNetworkTest',
      method: 'post',
      data
    })
  },

  batchDeleteDevice: (data) => {
    return request({
      url: '/api/device/batchDelete',
      method: 'post',
      data
    })
  },

  getDeviceLocationLatest: (params) => {
    return request({
      url: '/api/device/location/latest',
      method: 'get',
      params
    })
  },

  initDeviceFileUpload: (data) => {
    return request({
      url: '/api/v1/files/init',
      method: 'post',
      data
    })
  },

  uploadDeviceFileChunk: (data) => {
    return request({
      url: '/api/v1/files/chunk',
      method: 'post',
      data,
      headers: {
        'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/octet-stream'
      }
    })
  },

  completeDeviceFileUpload: (data) => {
    return request({
      url: '/api/v1/files/complete',
      method: 'post',
      data
    })
  },

  reportDeviceDeleteResult: (data) => {
    return request({
      url: '/api/v1/files/delete-result',
      method: 'post',
      data
    })
  },

  getOpsDashboard: () => {
    return request({
      url: '/api/device_ops/dashboard',
      method: 'get'
    })
  },

  getOpsTasks: (params = {}) => {
    return request({
      url: '/api/device_ops/tasks',
      method: 'get',
      params
    })
  },

  getOpsUploads: (params = {}) => {
    return request({
      url: '/api/device_ops/uploads',
      method: 'get',
      params
    })
  },

  getOpsEvents: (params = {}) => {
    return request({
      url: '/api/device_ops/events',
      method: 'get',
      params
    })
  },

  getOpsPackages: (params = {}) => {
    return request({
      url: '/api/device_ops/packages',
      method: 'get',
      params
    })
  },

  saveOpsPackage: (data) => {
    return request({
      url: '/api/device_ops/savePackage',
      method: 'post',
      data
    })
  }
}

// 导出默认实例和api对象
export default request
export { api }
